import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_written_job_desc_or_job_application_forms_that_reference_ot'

export const dataPointDefinition = {
  retracedId: 'are_written_job_desc_or_job_application_forms_that_reference_ot',
  name: 'Are written job description or job application forms that reference other discriminatory factors in line with legal requirements?',
  description:
    'Consult applicable legal requirements before answering this question.\r\r\n\r\r\nDetermine whether there are any other grounds of discrimination protected under applicable legislation, for example, illness (other than HIV/AIDS). "Other" refers to such additional grounds. If there are no applicable legal requirements covering the other ground(s) referred to in the job description or job application forms, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-dis-18',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5450,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
